export default {
  methods: {
    redirectAfterLogin () {
      let redirectPath = '/'

      if (this.$route.query.redirect) {
        redirectPath = this.$route.query.redirect
      }

      this.$router.push(redirectPath).catch(() => {})
    }
  }
}
